import React from "react";
import {Typography} from "@mui/material";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {hasError: false};
    }

    static getDerivedStateFromError() {
        return {hasError: true};
    }

    componentDidCatch(error, info) {
        console.error("Layout error:", error, info);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{display: "flex", justifyContent: "center", alignItems: "center", height: "100vh"}}>
                    <Typography>Something went wrong. Please try again.</Typography>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
